import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import SegmentHeader from './SegmentHeader/SegmentHeader';
import GroupQuestionsContainer from './GroupQuestions/GroupQuestionsContainer';
import Button from '../../../directives/Button/Button';
import * as Styled from './Style';
/**
 *  Комметарий по заказу
 */
const OrderFeedback = ({
  groups,
  questions,
  submitHandler,
  isLoading,
  isDisabled,
  errorsIds
}) => {
  if (!questions.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Styled.Container, null, /*#__PURE__*/React.createElement("div", null, groups.map((group, index) => /*#__PURE__*/React.createElement(GroupQuestionsContainer, {
    // eslint-disable-next-line react/no-array-index-key
    key: `GroupQuestionsContainer-${index}`,
    errorsIds: errorsIds,
    ...group,
    header: group.segment ? /*#__PURE__*/React.createElement(SegmentHeader, group.segment) : null
  }))), /*#__PURE__*/React.createElement(Styled.Footer, null, /*#__PURE__*/React.createElement(Button, {
    onClick: submitHandler,
    color: "red",
    isLoading: isLoading,
    isDisabled: isLoading || isDisabled
  }, I18n.t('components.OrderFeedback.button_send'))));
};
OrderFeedback.propTypes = {
  /** массив ошибок вопросов */errorsIds: PropTypes.array,
  /** Группы опросника */groups: PropTypes.array.isRequired,
  /** Вопросы опросника */questions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  /** Нажатие на кнопку Отправить */submitHandler: PropTypes.func.isRequired,
  /** Флаг того что форма в состоянии ожидания */isLoading: PropTypes.bool,
  /** Флаг того что форма в состоянии dissabled */isDisabled: PropTypes.bool
};
export default hot(/*#__PURE__*/memo(OrderFeedback));